<div
  v-if="is_mobile_panel_view && !is_collapsed"
  class="onboarding-ai-mobile-backdrop"
  @click="toggle_collapsed"
></div>

<aside class="onboarding-ai-panel" :class="panel_classes">
  <button
    v-if="is_collapsed"
    type="button"
    class="onboarding-ai-collapsed-button"
    @click="toggle_collapsed"
    aria-label="Open OnboardOS AI"
  >
    <span class="onboarding-ai-icon d-inline-flex align-items-center justify-content-center">
      <i class="bi bi-stars"></i>
    </span>
    <span class="onboarding-ai-collapsed-text">AI</span>
  </button>

  <div v-else class="onboarding-ai-panel-content">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div class="d-flex align-items-center gap-3 min-w-0">
        <span class="onboarding-ai-icon d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="bi bi-stars"></i>
        </span>
        <span class="fw-bold text-black text-truncate">OnboardOS AI</span>
      </div>

      <div class="d-flex align-items-center gap-2 flex-shrink-0">
        <span class="badge rounded-pill text-bg-light">LIVE</span>
        <button
          type="button"
          class="onboarding-ai-panel-tool"
          :aria-label="expand_label"
          :title="expand_label"
          @click="toggle_fullscreen"
        >
          <i :class="['bi', is_fullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen']"></i>
        </button>
        <button
          type="button"
          class="onboarding-ai-panel-tool"
          aria-label="Close OnboardOS AI"
          title="Close"
          @click="toggle_collapsed"
        >
          <i class="bi bi-layout-sidebar-inset-reverse"></i>
        </button>
      </div>
    </div>

    <section class="mb-4">
      <div class="text-uppercase onboarding-section-label text-muted mb-3">{{ summary_label }}</div>
      <p class="text-muted mb-3">
        {{ resolved_summary_intro }}
      </p>
      <div class="onboarding-ai-brief text-white p-3">
        <p class="mb-3">
          {{ resolved_briefing_body }}
        </p>
        <p class="mb-0 small text-white-50">{{ resolved_briefing_meta }}</p>
      </div>
    </section>

    <section class="mb-4">
      <div class="text-uppercase onboarding-section-label text-muted mb-3">Ask onboarding</div>
      <div class="d-grid gap-2">
        <button
          v-for="question in resolved_questions"
          :key="question"
          type="button"
          class="btn btn-outline-secondary text-start d-flex align-items-center gap-2 onboarding-question-btn"
          @click="queue_question(question)"
        >
          <i class="bi bi-record-circle"></i>
          <span>{{ question }}</span>
        </button>
      </div>
      <div class="input-group mt-2 onboarding-ai-input">
        <input
          v-model="draft_question"
          type="text"
          class="form-control"
          :placeholder="input_placeholder"
          @keyup.enter="submit_question"
        />
        <button class="btn btn-primary" type="button" aria-label="Send question" @click="submit_question">
          <i class="bi bi-send"></i>
        </button>
      </div>
    </section>

    <section>
      <div class="text-uppercase onboarding-section-label text-muted mb-3">Recent evidence</div>
      <div class="d-grid gap-2">
        <article
          v-for="item in recent_evidence"
          :key="item.title"
          class="d-flex align-items-center gap-3 onboarding-evidence-item"
        >
          <span
            class="onboarding-evidence-icon d-inline-flex align-items-center justify-content-center"
            :class="evidence_icon_class(item.tone)"
          >
            <i :class="['bi', item.icon]"></i>
          </span>
          <div class="min-w-0 flex-grow-1">
            <div class="fw-semibold text-truncate">{{ item.title }}</div>
            <div class="small text-muted text-truncate">{{ item.meta }}</div>
          </div>
          <span class="badge rounded-pill" :class="evidence_badge_class(item.tone)">{{ item.status }}</span>
        </article>
      </div>
    </section>
  </div>
</aside>
